(() => {
  const OnMutate = (targetNodes, callback) => {
    var observer = new MutationObserver(callback);

    // Notify me of everything!
    var observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true
    };

    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });
  };

  document.addEventListener('alpine:init', () => {
    Alpine.data('HeaderAnnouncements', () => ({
      init() {
        let $announcement_bar = document.querySelector('announcement-bar')
        if (!$announcement_bar) return;

        let am = this;
        let $clone_announcement_bar = $announcement_bar.cloneNode(true)
        $clone_announcement_bar.classList.add('small-hide')
        am.$el.insertAdjacentElement('beforeend', $clone_announcement_bar)
      }
    }))

    Alpine.data('FooterSocialList', () => ({
      init() {
        let am = this;
        am.$el.querySelectorAll('.list-social__item').forEach(($item) => {
          $item.querySelector('.visually-hidden').classList.remove('visually-hidden')
          $item.querySelector('svg').classList.add('hidden')

          let $link = $item.querySelector('a')
          $link.classList.remove('list-social__link', 'link-with-icon')
          $link.classList.add('list-menu__item--link')
        })
      }
    }))

    Alpine.data('LogosSwiper', () => ({
      init() {
        let am = this;
        let sw_options = {
          slidesPerView: "auto",
          spaceBetween: 25,
          speed: 6000,
          autoplay: {
            delay: 1,
          },        
          loop: true,
          breakpoints: {
            750: {
              spaceBetween: 55,
              speed: 3000,
            }
          }
        };
        new Swiper(am.$el, sw_options);
      }
    }))

    Alpine.data('VariantInfo', () => ({
      prop_labels: [],
      prop_values: [],
      variant_id: '',
      variants: [],
      init() {
        let am = this;
        
        am.$watch('variant_id', am.SetProps.bind(am))

        am.variants = JSON.parse(am.$el.dataset.variants)
        am.variant_id = am.$el.dataset.variant_id

        document.addEventListener('variant:change', (e) => {
          am.variant_id = e.detail.variant.id;
          am.$el.querySelector('.selected-variant').textContent = e.detail.variant.options.join(' ');
          am.UpdateVariantMedia();
        });
      },
      SetProps() {
        let am = this;
        let variant = am.variants.find(v => v.id == am.variant_id)
        am.prop_labels = [1,2,3].map(index => {
          return variant[`prop_${ index }`].split(';')[0]
        })
        am.prop_values = [1,2,3].map(index => {
          return variant[`prop_${ index }`].split(';')[1]
        })
      },
      UpdateVariantMedia() {
        if (!_enable_variant_images) return;
        let am = this;
        let $media_gallery = document.querySelector('media-gallery');
        let $container = $media_gallery.closest('.product__media-wrapper');
        let $section = $media_gallery.closest('.shopify-section');
        let section_id = $section.getAttribute('id').replace('shopify-section-', '');
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        (async() => {
          let url = `${window.location.pathname}?variant=${am.variant_id}&sections=${section_id}`;
          let res = await fetch(url).then(res => res.json());

          let parser = new DOMParser();
          let $variant_gallery = parser.parseFromString(res[section_id], 'text/html').body.querySelector('media-gallery');
          $variant_gallery.querySelectorAll('img').forEach($img => $img.removeAttribute('srcset'));
          $media_gallery.insertAdjacentElement('beforebegin', $variant_gallery);
          $container.scrollTo({
            top: 0
          });
          $media_gallery.remove();
          // console.log($variant_gallery);
        })();
      }
    }))

    Alpine.data('Ticker', () => ({
      MQ_desk: window.matchMedia("(min-width: 750px)"),
      init() {
        let am = this;
        am.SetTickerProps();
        am.MQ_desk.addEventListener('change', am.SetTickerProps.bind(am));
      },
      SetTickerProps() {
        let am = this;
        let $ticker = am.$el.querySelector('.swiper-wrapper');
        let $items = $ticker.querySelectorAll('.swiper-slide');
        let items_width = [...$items].reduce((sum, $item) => sum + $item.offsetWidth , 0);
        am.$el.style.setProperty('--ticker_width', `${(0 - items_width)}px`);
        am.$el.style.setProperty('--ticker-duration', am.MQ_desk.matches ? `${(items_width * 1)/100}s` : `${(items_width * 2)/100}s`);
      }
    }));
  });

  let url_params = new URLSearchParams(window.location.search);
  let cart_state = url_params.get('cart');
  if (cart_state == 'on') {
    document.querySelector('cart-drawer summary').click();
  }
})()